import { render, staticRenderFns } from "./ScoresActionPlan.vue?vue&type=template&id=5d58b12e&scoped=true&"
import script from "./ScoresActionPlan.vue?vue&type=script&lang=js&"
export * from "./ScoresActionPlan.vue?vue&type=script&lang=js&"
import style0 from "./ScoresActionPlan.vue?vue&type=style&index=0&id=5d58b12e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58b12e",
  null
  
)

export default component.exports